import { WeatherType } from './Limitation';

/**
 * 固定選項的天氣類型：值是氣象代碼區間，看不出是哪一種天氣。
 *
 * 明細標籤那側（`getLimitationContentLabel`）預設是拿「值」去組 i18n key 的，
 * 對這種值組出來的 `limitation.labels.42` 不存在，就會退回顯示存檔當下那個語系的
 * label、切語系不會變。兩邊都查這張表，選單與標籤才會是同一組文案。
 *
 * 數值區間型（溫度／降雨機率／相對濕度）的值由使用者拉出來、沒有固定選項，不在此列。
 */
export const WEATHER_OPTION_I18N_KEYS: Partial<
  Record<WeatherType, { [value: string]: string }>
> = {
  [WeatherType.UV_INDEX]: {
    '0~2': 'limitation.labels.options.uvIndex.low',
    '3~5': 'limitation.labels.options.uvIndex.moderate',
    '6~7': 'limitation.labels.options.uvIndex.high',
    '8~10': 'limitation.labels.options.uvIndex.veryHigh',
    '11~': 'limitation.labels.options.uvIndex.extreme'
  },
  [WeatherType.WEATHER_CODE]: {
    '1~3,24~27': 'limitation.labels.options.weatherCode.sunny',
    '4~7,28': 'limitation.labels.options.weatherCode.cloudy',
    '8~23,29~41': 'limitation.labels.options.weatherCode.rainy',
    '42': 'limitation.labels.options.weatherCode.snowy'
  }
};

export function getWeatherOptionI18nKey(
  type: string,
  value: string
): string | undefined {
  return WEATHER_OPTION_I18N_KEYS[type as WeatherType]?.[value];
}
